var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationO(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4C13.3137 4 16 6.68629 16 10C16 13.3137 13.3137 16 10 16C6.68629 16 4 13.3137 4 10C4 6.68629 6.68629 4 10 4ZM10 11C9.58704 11 9.22814 11.1518 8.92383 11.4561C8.64122 11.7387 8.5 12.087 8.5 12.5C8.5 12.913 8.64122 13.2718 8.92383 13.5762C9.22818 13.8588 9.58696 14 10 14C10.413 14 10.7613 13.8588 11.0439 13.5762C11.3482 13.2719 11.5 12.913 11.5 12.5C11.5 12.087 11.3483 11.7387 11.0439 11.4561C10.7613 11.1517 10.413 11 10 11ZM8.89648 6C8.68596 6 8.52272 6.18466 8.54883 6.39355L8.96191 9.69336C8.98379 9.86838 9.13225 9.99981 9.30859 10H10.6914C10.8678 9.99981 11.0162 9.86838 11.0381 9.69336L11.4512 6.39355C11.4773 6.18466 11.314 6 11.1035 6H8.89648Z",
    fill: "#DC7D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationO);
export default __webpack_public_path__ + "static/media/exclamation-o.9eaf217efbc215fb6f52edd9ae81c210.svg";
export { ForwardRef as ReactComponent };